module.exports = __webpack_public_path__ + "img/next.6a407167.png";